/**
 * <TutorPreCallPage> — avant d'entrer dans son live, le masteur vérifie son matériel (page).
 *
 * L'ancien `PreCallScreen` (route `pre-call`) quand c'est le masteur qui y passe : le même test guidé
 * que l'élève (connexion, micro, haut-parleurs, caméra — `<LiveLobbyDeviceStrip>`,
 * `<DeviceCheckStep>`, `<LiveLobbyPreview>`, et `<LiveBrowserChoice>` hors de Chrome), donc la même
 * page (`<StudentLiveEntryPage>`), dans ses mots : « Prêt à entrer dans ton live ? », « Entrer dans
 * mon live », « Entrer sans vérifier » avant le test et « Entrer sans finir » pendant (`joinBeforeCheck`
 * de la page). Ce que le masteur n'a pas : Sam qui l'attend, l'alerte au technicien — l'écran ne les
 * passe pas. Les phrases du test qui lui parlent de ses élèves (« Pour
 * que tes élèves te voient et t'entendent… ») arrivent par les lignes et les conseils, comme
 * aujourd'hui (`deviceCheckCopy`, côté tuteur).
 */
import React from "react"

import {
    StudentLiveEntryPage,
    type StudentLiveEntryPageProps,
    type UILiveEntryWording,
} from "../StudentLiveEntryPage/StudentLiveEntryPage"

export type TutorPreCallPageProps = Omit<StudentLiveEntryPageProps, "wording" | "samWaiting">

/** Les mots du masteur ; avant le test, l'entrée de l'ancien écran (`deviceCheckCopy`, côté tuteur, `enterBefore`). */
const TUTOR_PRECALL_WORDING: UILiveEntryWording = {
    question: "Prêt à entrer dans ton live ?",
    join: "Entrer dans mon live",
    joinUnfinished: "Entrer sans finir",
    joinBefore: "Entrer sans vérifier",
    equipment: "Ton matériel",
}

export function TutorPreCallPage(props: TutorPreCallPageProps) {
    return <StudentLiveEntryPage {...props} wording={TUTOR_PRECALL_WORDING} />
}
